exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width:1200px){.select-list[data-v-083039a0]{margin:auto;padding-left:1.5rem;padding-right:1.5rem;max-width:348px;height:270px;overflow-x:hidden;overflow-y:auto}.is-selected[data-v-083039a0]{background-color:var(--black-light-1);margin-left:-1.5rem;margin-right:-1.5rem;padding-left:1.5rem;padding-right:1.5rem}}@media(max-width:600px){.select-list[data-v-083039a0]{max-width:100%;padding-left:0;padding-right:0}}", ""]);

// exports
